;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"5befa1b3a4490d35be7c84c2eb9a44b423bfcafa"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/play";import * as Sentry from '@sentry/nextjs';

import {
  CORE_ERROR_PATTERNS,
  createBeforeSend,
  PHASER_ERROR_PATTERNS,
  WEBRTC_ERROR_PATTERNS,
  WHALE_BROWSER_ERROR_PATTERNS,
} from '@zep/sentry';

import baseOptions from '../../sentry.base.config';

Sentry.init({
  ...baseOptions,
  beforeSend: createBeforeSend({
    ignorePatterns: [
      ...CORE_ERROR_PATTERNS,
      ...PHASER_ERROR_PATTERNS,
      ...WEBRTC_ERROR_PATTERNS,
      ...WHALE_BROWSER_ERROR_PATTERNS,
    ],
  }),
});
